<template>
  <div id="apf">
    <div v-if="!isSubmitted && !isDraft" class="container">
      <img
        :src="selectOptSchool === schools.City ? 'https://kws.etonhouse.com/images/city_logo_colored.png' : 'https://kws.etonhouse.com/images/eps_logo.png'"
        style="width: 300px; padding-block: 20px; margin-bottom: 20px"
      />

      <h4 class="text-red">Student Application Form</h4>
      <div class="row" style="margin: 0 0 25px 0">
        {{ apfConfig.PRE.introduction }}
      </div>

      <div class="row" style="margin: 0 0 25px 0">
        <ApfSelectSchoolDropdown
          :school="selectOptSchool"
          @change="onSchoolChange($event)"
          :preschoolInfo="preschoolInfo"
          :validator="$v.selectOptSchool"
          group="PRE"
        />
        <ApfUploadStudentPhoto @change="onFileChanged($event, 'stuIMG')" :currentStuImg="currentStudentImgPreview" />
        <!--<ApfUploadStudentPhoto @change="uploadedStuImg = $event"/>-->
      </div>

      <div v-show="selectOptSchool">
        <div class="saf-step-container" style="margin-bottom: 30px">
          <el-steps :active="currentStep">
            <el-step
              v-for="(item, index) in apfConfig.preSteps"
              :title="item.title"
              :key="index"
              :description="item.desc"
              @click.native="clickStep(index)"
            ></el-step>
          </el-steps>
        </div>

        <div>
          <span style="display: block; color: #dc2826; font-weight: bold">Step {{ currentStep + 1 }}</span>
        </div>

        <div class="saf-student-details-cotainer" v-if="currentStep === 0" style="position: relative">
          <div style="margin-bottom: 20px">
            <label class="common-label-title">Student Details</label>
            <small>(Please provide a written notice to the Parent Liaison Office of any changes to the information provided in this form.)</small>
          </div>

          <div style="display: grid; grid-template-columns: 1fr 1fr; row-gap: 1.5rem; column-gap: 3rem">
            <ApfBasicInput name="studFirstName" label="First Name" :validator="$v">
              <input class="form-control" type="text" v-model="studFirstName" />
            </ApfBasicInput>

            <ApfBasicInput name="studLastName" label="Last Name" :validator="$v">
              <input class="form-control" type="text" v-model="studLastName" />
            </ApfBasicInput>

            <ApfBasicInput name="APF_Preferred_Name" label="Chinese Name (if applicable)" :validator="$v">
              <input class="form-control" type="text" v-model="APF_Preferred_Name" />
            </ApfBasicInput>

            <ApfBasicInput name="studDOB" label="Date of Birth" :validator="$v">
              <el-date-picker
                type="date"
                v-model="studDOB"
                format="dd/MM/yyyy"
                value-format="dd/MM/yyyy"
                placeholder="Pick a day"
                :picker-options="datePicker"
              />
            </ApfBasicInput>

            <ApfBasicInput name="inputFirstCommencementDate" label="Commencement Date" :validator="$v">
              <el-date-picker
                type="date"
                v-model="inputFirstCommencementDate"
                format="dd/MM/yyyy"
                value-format="dd/MM/yyyy"
                placeholder="Pick a day"
                :picker-options="CommDatePicker"
                @change="checkStudentAge()"
              />
              <!--							jess: hide temporary for calculation inaccurate 08102024 -->
              <!--							<div v-if="autoLevel" class="autoLevel">Level: {{ autoLevel }}</div>-->
            </ApfBasicInput>

            <ApfBasicInput name="studGender" label="Gender" :validator="$v">
              <select class="form-control" v-model="studGender">
                <option value="Male">Male</option>
                <option value="Female">Female</option>
              </select>
            </ApfBasicInput>

            <ApfBasicInput name="studCOB" label="Country of Birth" :validator="$v">
              <select class="form-control" v-model="studCOB" style="width: 100%">
                <option v-for="items in arrCountryList" :key="`COB_${items.CNYid}`" :value="items.CNYname.trim()">
                  {{ items.CNYname }}
                </option>
              </select>
            </ApfBasicInput>

            <ApfBasicInput name="studNationality" label="Nationality" :validator="$v">
              <select class="form-control" v-model="studNationality" style="width: 100%">
                <option v-for="items in arrCountryList" :key="`SN_${items.CNYid}`" :value="items.CNYnationality.trim()">
                  {{ items.CNYnationality }}
                </option>
              </select>
            </ApfBasicInput>

            <ApfBasicInput name="studCurrentSchName" label="Current School Name" :validator="$v">
              <input class="form-control" type="text" v-model="studCurrentSchName" />
            </ApfBasicInput>

            <ApfBasicInput name="studCurrentSchCountry" label="Current School Country" :validator="$v">
              <select class="form-control" v-model="studCurrentSchCountry" style="width: 100%">
                <option v-for="items in arrCountryList" :key="`SSC_${items.CNYid}`" :value="items.CNYname.trim()">
                  {{ items.CNYname }}
                </option>
              </select>
            </ApfBasicInput>

            <ApfBasicInput name="studIsEnrolled" :validator="$v" label="Has your child been enrolled with EtonHouse previously?">
              <select class="form-control" v-model="studIsEnrolled">
                <option value="yes">Yes</option>
                <option value="no">No</option>
              </select>
            </ApfBasicInput>

            <ApfBasicInput v-if="studIsEnrolled === 'yes'" label="Please select which EtonHouse school">
              <select class="form-control" v-model="studIsEnrolledSchool">
                <option v-for="opt in schoolNameList" :value="opt.SchoolID" :key="opt.id">
                  {{ opt.SchoolName }}
                  <template v-if="opt.SchoolID === 'SCH201500000043' || opt.SchoolID === 'SCH201400000537'"> (Pre-School) </template>
                </option>
              </select>
            </ApfBasicInput>

            <ApfBasicInput name="studPassApplication" label="Do you need to apply for student pass?" :validator="$v">
              <select class="form-control" v-model="studPassApplication" @change="onSelection($event)">
                <option value="yes">Yes</option>
                <option value="no">No</option>
              </select>
            </ApfBasicInput>

            <ApfBasicInput v-if="studPassApplication === 'no'" name="studImmigrationStatus" label="Immigration Status" :validator="$v">
              <select class="form-control" v-model="studImmigrationStatus">
                <option value="DP(Dependant Pass)">Dependent's Pass</option>
                <option value="LTVP(Long Term Visit Pass)">Long Term Visit Pass</option>
                <option value="PR(Permanent Resident)">Permanent Resident</option>
                <option value="SC(Citizen)">Singapore Citizen</option>
              </select>
            </ApfBasicInput>

            <ApfBasicInput name="studImmigrationStatusNo" label="Passport No./NRIC No./Birth Certificate No./FIN No." :validator="$v">
              <input class="form-control" type="text" v-model="studImmigrationStatusNo" />
            </ApfBasicInput>

            <ApfBasicInput label="Expiry Date">
              <el-date-picker type="date" v-model="studImmigrationStatusNoExpiryDate" format="dd/MM/yyyy" value-format="dd/MM/yyyy" placeholder="Pick a day" />
            </ApfBasicInput>

            <ApfBasicInput name="studFirstLanguage" label="First(1st) Language" :validator="$v">
              <input class="form-control" type="text" v-model="studFirstLanguage" />
            </ApfBasicInput>

            <ApfBasicInput label="Second(2nd) Language (if applicable)">
              <input class="form-control" type="text" v-model="studSecondLanguage" />
            </ApfBasicInput>

            <ApfBasicInput label="Does your child have siblings?">
              <select class="form-control" v-model="isStudHasSibling">
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>
            </ApfBasicInput>

            <ApfBasicInput style="grid-column: 1/-1" label="Add Sibling's Details">
              <K2Row style="margin: 0.5rem 0" align="flex-end">
                <div class="flex-1 me-3">
                  <label>Name</label>
                  <input class="form-control mb-0" type="text" v-model="studSiblingName" />
                </div>

                <div class="flex-1 me-3">
                  <label>Gender</label>
                  <select class="form-control mb-0" v-model="studSiblingGender">
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                  </select>
                </div>

                <div class="flex-1 me-3">
                  <label>Date of Birth</label>
                  <el-date-picker
                    type="date"
                    v-model="studSiblingDOB"
                    format="dd/MM/yyyy"
                    value-format="dd/MM/yyyy"
                    placeholder="Pick a day"
                    :picker-options="datePicker"
                  />
                </div>
                <div class="flex-1 me-3">
                  <label>Current School</label>
                  <select class="form-control mb-0" v-model="studSiblingPresentSch">
                    <option :value="school.SchoolID" v-for="school in ddlSchoool" :key="school.SchoolID">
                      {{ school.SchoolName }}
                    </option>
                    <option value="other">Other</option>
                    <option value="notSchoolGoing">Not School Going</option>
                  </select>
                </div>
                <div class="flex-1 me-3" v-if="studSiblingPresentSch === 'other'">
                  <label>Other School</label>
                  <input class="form-control mb-0" type="text" v-model="studSiblingOtherSch" />
                </div>
                <div class="flex-1 me-3" v-if="studSiblingPresentSch === 'notSchoolGoing'">
                  <label>Age</label>
                  <input class="form-control mb-0" type="text" v-model="studSiblingAge" />
                </div>
                <div>
                  <button @click="addStudSibling()" class="btn common-btn" style="margin-right: auto; color: white; padding: 6px 36px">Add</button>
                </div>
              </K2Row>

              <div v-if="studArrSiblingDetails.length > 0" style="width: 100%">
                <data-tables :data="studArrSiblingDetails" :action-col="studArrSiblingDetailsListAction">
                  <el-table-column v-for="keyTag in studArrSiblingDetailsList" :prop="keyTag.prop" :label="keyTag.label" :key="keyTag.prop" sortable="custom">
                  </el-table-column>
                </data-tables>
              </div>
            </ApfBasicInput>
          </div>

          <hr />
          <ApfLanguageSection
            group="EH"
            :school="selectOptSchool"
            :preschoolInfo="preschoolInfo"
            :validator="$v"
            @selectedAddLanguage="additionalLangValue = $event"
            :form="$data"
          />
        </div>

        <div class="saf-parent-guarding-details-container" v-if="currentStep === 1">
          <div>
            <label class="common-label-title">Parent(s) Details</label>
          </div>

          <div>
            <div class="stud-legal-rights-container">
              <label>Student's Legal Rights</label>
              <p>
                Under Singapore law, a person under 21 years of age is considered a minor and the parents/local guardians are responsible for the Student. The
                decision making rights of a minor vest in the parents/local guardians. Where parents of the Student divorced/separated, the School will follow
                an order of court to determine the party/parties that has/have custody of the Student and therefore, is responsible for making decisions for the
                Student.
              </p>

              <label>Please select an option</label>
              <div>
                <el-select v-model="selectOptParent" class="w-100 mb-4">
                  <el-option v-for="(opt, idx) in arrOptParent" :key="`arropt-${idx}`" :label="opt.name" :value="opt.value"> </el-option>
                </el-select>
              </div>
            </div>

            <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 3rem">
              <div
                style="display: grid; gap: 1.5rem"
                :class="selectOptParent === 'father' ? 'single' : ''"
                v-if="selectOptParent === 'father' || selectOptParent === 'fnm'"
              >
                <div>
                  <label><img src="../../assets/VectorMale.png" /> Father</label>
                  <hr style="margin-bottom: 0" />
                </div>

                <ApfBasicInput name="faFirstName" label="First Name" :validator="$v">
                  <input class="form-control" type="text" v-model="faFirstName" />
                </ApfBasicInput>

                <ApfBasicInput name="faLastName" label="Last Name" :validator="$v">
                  <input class="form-control" type="text" v-model="faLastName" />
                </ApfBasicInput>

                <ApfBasicInput label="Middle Name">
                  <input class="form-control" type="text" v-model="faMiddleName" />
                </ApfBasicInput>

                <ApfBasicInput label="Date of Birth">
                  <el-date-picker
                    type="date"
                    v-model="APFP_FatherDob"
                    format="dd/MM/yyyy"
                    value-format="dd/MM/yyyy"
                    placeholder="Pick a day"
                    :picker-options="datePicker"
                  />
                </ApfBasicInput>

                <ApfBasicInput name="faNationality" label="Nationality" :validator="$v">
                  <select class="form-control" v-model="faNationality" style="width: 100%">
                    <option v-for="items in arrCountryList" :key="`FN_${items.CNYid}`" :value="items.CNYnationality.trim()">
                      {{ items.CNYnationality }}
                    </option>
                  </select>
                </ApfBasicInput>

                <ApfBasicInput name="faEmail" label="Email" :validator="$v">
                  <input class="form-control" type="email" v-model="faEmail" />
                </ApfBasicInput>

                <ApfBasicInput name="faTelM" label="Tel (Mobile)" :validator="$v">
                  <AppInputPhoneNumber v-model="faTelM" :validator="$v.faTelM" />
                </ApfBasicInput>

                <ApfBasicInput label="Tel (Home)">
                  <AppInputPhoneNumber v-model="faTelH" />
                </ApfBasicInput>

                <ApfBasicInput name="faResidencyDocNo" label="Passport No. (NRIC for Singapore Citizen/PR)" :validator="$v">
                  <input class="form-control" type="text" v-model="faResidencyDocNo" />
                </ApfBasicInput>

                <ApfBasicInput label="Expiry Date">
                  <el-date-picker type="date" v-model="faResidencyDocExpiry" format="dd/MM/yyyy" value-format="dd/MM/yyyy" placeholder="Pick a day" />
                </ApfBasicInput>

                <ApfBasicInput label="Company Name" :validator="$v" name="faCompanyName">
                  <input class="form-control" type="text" v-model="faCompanyName" />
                </ApfBasicInput>

                <ApfBasicInput label="Occupation" :validator="$v" name="faOccupation">
                  <input class="form-control" type="text" v-model="faOccupation" />
                </ApfBasicInput>
              </div>

              <div
                style="display: grid; gap: 1.5rem"
                :class="selectOptParent === 'mother' ? 'single' : ''"
                v-if="selectOptParent === 'mother' || selectOptParent === 'fnm'"
              >
                <div>
                  <label><img src="../../assets/VectorFemale.png" />Mother</label>
                  <hr style="margin-bottom: 0" />
                </div>

                <ApfBasicInput name="maFirstName" label="First Name" :validator="$v">
                  <input class="form-control" type="text" v-model="maFirstName" />
                </ApfBasicInput>

                <ApfBasicInput name="maLastName" label="Last Name" :validator="$v">
                  <input class="form-control" type="text" v-model="maLastName" />
                </ApfBasicInput>

                <ApfBasicInput label="Middle Name">
                  <input class="form-control" type="text" v-model="maMiddleName" />
                </ApfBasicInput>

                <ApfBasicInput label="Date of Birth">
                  <el-date-picker
                    type="date"
                    v-model="APFP_MotherDob"
                    format="dd/MM/yyyy"
                    value-format="dd/MM/yyyy"
                    placeholder="Pick a day"
                    :picker-options="datePicker"
                  />
                </ApfBasicInput>

                <ApfBasicInput name="maNationality" label="Nationality" :validator="$v">
                  <select class="form-control" v-model="maNationality" style="width: 100%">
                    <option v-for="items in arrCountryList" :key="`MN_${items.CNYid}`" :value="items.CNYnationality.trim()">
                      {{ items.CNYnationality }}
                    </option>
                  </select>
                </ApfBasicInput>

                <ApfBasicInput name="maEmail" label="Email" :validator="$v">
                  <input class="form-control" type="email" v-model="maEmail" />
                </ApfBasicInput>

                <ApfBasicInput name="maTelM" label="Tel (Mobile)" :validator="$v">
                  <AppInputPhoneNumber v-model="maTelM" :validator="$v.maTelM" />
                </ApfBasicInput>

                <ApfBasicInput label="Tel (Home)">
                  <AppInputPhoneNumber v-model="maTelH" />
                </ApfBasicInput>

                <ApfBasicInput name="maResidencyDocNo" label="Passport No. (NRIC for Singapore Citizen/PR)" :validator="$v">
                  <input class="form-control" type="text" v-model="maResidencyDocNo" />
                </ApfBasicInput>

                <ApfBasicInput label="Expiry Date">
                  <el-date-picker type="date" v-model="maResidencyDocExpiry" format="dd/MM/yyyy" value-format="dd/MM/yyyy" placeholder="Pick a day" />
                </ApfBasicInput>

                <ApfBasicInput label="Company Name" :validator="$v" name="maCompanyName">
                  <input class="form-control" type="text" v-model="maCompanyName" />
                </ApfBasicInput>

                <ApfBasicInput label="Occupation" :validator="$v" name="maOccupation">
                  <input class="form-control" type="text" v-model="maOccupation" />
                </ApfBasicInput>
              </div>
            </div>

            <div class="input-group mt-3">
              <label>Annual Household income</label>
              <label style="margin-right: 1rem" class="radio-inline ms-3" v-for="val in preSchools.optIncome" :key="val">
                <input type="radio" v-model="parHouseholdIncome" :value="val" /> {{ val }}
              </label>
            </div>
            <hr />

            <div class="emergency-contact-container">
              <div class="header-a">
                <strong>Emergency Contact</strong>
                <small>(Alternative English-speaking person in Singapore in case of emergency if parents/guardian are not contactable.)</small>
              </div>

              <div style="display: grid; grid-template-columns: repeat(4, auto); row-gap: 1rem; column-gap: 2rem; margin-bottom: 2rem">
                <ApfBasicInput name="emgPerson1" label="Person 1" :validator="$v">
                  <input class="form-control" type="text" v-model="emgPerson1" />
                </ApfBasicInput>

                <ApfBasicInput name="emgRelationship1" label="Relationship" :validator="$v">
                  <input class="form-control" type="text" v-model="emgRelationship1" />
                </ApfBasicInput>

                <ApfBasicInput name="emgTelM1" label="Tel (Mobile)" :validator="$v">
                  <AppInputPhoneNumber v-model="emgTelM1" :validator="$v.emgTelM1" />
                </ApfBasicInput>

                <ApfBasicInput label="Tel (Home)">
                  <AppInputPhoneNumber v-model="emgTelH1" />
                </ApfBasicInput>

                <ApfBasicInput label="Person 2">
                  <input class="form-control" type="text" v-model="emgPerson2" />
                </ApfBasicInput>

                <ApfBasicInput label="Relationship">
                  <input class="form-control" type="text" v-model="emgRelationship2" />
                </ApfBasicInput>

                <ApfBasicInput label="Tel (Mobile)">
                  <AppInputPhoneNumber v-model="emgTelM2" />
                </ApfBasicInput>

                <ApfBasicInput label="Tel (Home)">
                  <AppInputPhoneNumber v-model="emgTelH2" />
                </ApfBasicInput>
              </div>
            </div>
            <strong>
              IMPORTANT: Should EtonHouse be unable to contact the child's parent or Emergency contact person, I give my permission to EtonHouse to seek medical
              assistance for my child, I will bear full financial responsibility to any cost incurred.
            </strong>
            <hr />

            <div class="correspondence-container">
              <div class="header-a">
                <strong>Correspondence</strong>
              </div>

              <ApfBasicInput name="corrResidingType" label="Student will be residing with" :validator="$v" style="margin-bottom: 1rem">
                <select class="form-control" v-model="corrResidingType">
                  <option value="father">Father</option>
                  <option value="mother">Mother</option>
                  <option value="parents">Parents</option>
                  <option value="guardian">Guardian</option>
                </select>
              </ApfBasicInput>

              <div
                v-if="corrResidingType === 'guardian'"
                style="
                  display: grid;
                  grid-template-columns: 1fr 1fr;
                  column-gap: 2rem;
                  row-gap: 1rem;
                  border: 1px solid lightgray;
                  padding: 1rem;
                  border-radius: 2px;
                  margin-bottom: 2rem;
                "
              >
                <div style="font-weight: bold; grid-column: 1 / -1"><img src="../../assets/VectorMale.png" /> Guardian</div>
                <ApfBasicInput label="Name">
                  <input class="form-control" type="text" v-model="gdName" />
                </ApfBasicInput>
                <ApfBasicInput label="Email">
                  <input class="form-control" type="text" v-model="gdEmail" />
                </ApfBasicInput>
                <ApfBasicInput label="Tel (Mobile)">
                  <AppInputPhoneNumber v-model="gdTelM" />
                </ApfBasicInput>
                <ApfBasicInput label="Tel (Home)">
                  <AppInputPhoneNumber v-model="gdTelH" />
                </ApfBasicInput>
              </div>

              <ApfBasicInput name="corrAddress" label="Address in Singapore" :validator="$v" style="margin-bottom: 1rem">
                <textarea class="form-control" rows="4" v-model="corrAddress"></textarea>
              </ApfBasicInput>

              <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 2rem">
                <ApfBasicInput name="corrAddressPostal" label="* Postal Code">
                  <input class="form-control" type="text" v-model="corrAddressPostal" />
                </ApfBasicInput>

                <ApfBasicInput name="corrAddressCountry" label="* Country">
                  <input class="form-control" type="text" v-model="corrAddressCountry" disabled />
                </ApfBasicInput>
              </div>
            </div>
            <hr />

            <div class="billing-details-container" style="display: grid; grid-template-columns: 1fr 1fr; row-gap: 1rem; column-gap: 2rem">
              <div class="header-a col-span-full m-0">
                <strong>Billing Name & Address for Tuition Fees (if different from above)</strong>
              </div>
              <ApfBasicInput class="col-span-full">
                <template slot="title">
                  <div class="label">
                    Billing Name
                    <span v-if="billName" @click="resetBillingInfo" class="text-danger"> Clear </span>
                  </div>
                </template>
                <el-select v-model="billName" clearable @change="onBillingNameChange" class="mt-2 w-100" @clear="resetBillingInfo">
                  <el-option key="father" label="Father" value="father"></el-option>
                  <el-option key="mother" label="Mother" value="mother"></el-option>
                  <el-option key="faCompany" label="Father Company" value="faCompany"></el-option>
                  <el-option key="maCompany" label="Mother Company" value="maCompany"></el-option>
                </el-select>
              </ApfBasicInput>
              <div :class="{ 'form-group--error col-span-full': $v.maCompanyName.$error }">
                <div class="error requiredFieldsMsg" v-if="!$v.maCompanyName.required">
                  <el-alert title="Please fill up mother company." type="error"></el-alert>
                </div>
              </div>
              <div :class="{ 'form-group--error col-span-full': $v.faCompanyName.$error }">
                <div class="error requiredFieldsMsg" v-if="!$v.faCompanyName.required">
                  <el-alert title="Please fill up father company." type="error"></el-alert>
                </div>
              </div>

              <ApfBasicInput label="Address" class="col-span-full">
                <textarea class="form-control" rows="4" v-model="billAddress" :disabled="!billName"></textarea>
              </ApfBasicInput>

              <ApfBasicInput name="billAddressPostal" :label="(billName && '*') + 'Postal Code'">
                <input class="form-control" type="text" v-model="billAddressPostal" :disabled="!billName" />
                <div :class="{ 'form-group--error col-span-full': $v.billAddressPostal.$error }">
                  <div class="error requiredFieldsMsg" v-if="!$v.billAddressPostal.required">
                    <el-alert title="Please fill up postal code." type="error"></el-alert>
                  </div>
                </div>
              </ApfBasicInput>

              <ApfBasicInput name="billAddressCountry" :label="(billName && '*') + 'Country'">
                <select class="form-control w-full" v-model="billAddressCountry" :disabled="!billName">
                  <option v-for="items in arrCountryList" :key="items.CNYid" :value="items.CNYname.trim()">
                    {{ items.CNYname }}
                  </option>
                </select>
              </ApfBasicInput>
              <ApfBasicInput name="billEmail" label="Email">
                <MultiEmailInput :email="billEmail" :validator="$v" @onChange="billEmail = $event" :disabled="!billName" />
              </ApfBasicInput>

              <ApfBasicInput label="Tel">
                <input class="form-control" type="text" v-model="billTel" :disabled="!billName" />
              </ApfBasicInput>
            </div>
          </div>
        </div>

        <div class="saf-supportive-information-container" v-if="currentStep === 2">
          <ApfQuestions
            :group="'PRE'"
            :hideBusFee="!preschoolInfo.addInfo"
            :school="selectOptSchool"
            :questions="questionAryObj"
            :validator="$v.questionAryObj"
            style="margin-bottom: 1rem"
          />

          <strong v-if="preschoolInfo && preschoolInfo.addInfo">
            {{ preschoolInfo.addInfo }}
          </strong>
          <hr />

          <div style="margin-bottom: 30px">
            <label style="color: #212121; font-weight: bold"
              >IMPORTANT: Should EtonHouse be unable to contact the child’s parent(s) or emergency contact person, I give permission to EtonHouse to seek
              medical assistance for my child. I will bear full financial responsibility for any cost incurred.</label
            >
          </div>

          <div style="display: grid; grid-template-columns: 1fr 1fr; column-gap: 2rem">
            <div>
              <ApfBasicInput name="siSignatureName" label="Name of Parent / Guardian" :validator="$v" style="margin-bottom: 1rem">
                <input class="form-control" type="text" v-model="siSignatureName" v-on:change="copySignaturenName()" />
              </ApfBasicInput>

              <ApfBasicInput label="* Date">
                <el-date-picker
                  disabled
                  type="date"
                  v-model="siSignatureDate"
                  format="dd/MM/yyyy"
                  value-format="dd/MM/yyyy"
                  placeholder="Pick a day"
                  :picker-options="datePicker"
                />
              </ApfBasicInput>
            </div>

            <ApfBasicInput name="siSignature" label="Signature" :validator="$v">
              <div v-on:click="$bvModal.show('signatureModal')" class="signature-pad">
                <img v-if="siSignature" :src="siSignature" type="file" class="imgParentSignature" />
              </div>
            </ApfBasicInput>
          </div>
        </div>

        <div class="saf-declration-agreement-container" v-if="currentStep === 3">
          <div>
            <div><label class="common-label-title">Declaration and Agreement</label></div>

            <div>
              <ApfDeclarationAndAgreement
                :validator="$v"
                :agreePublications="agreePublications"
                @changeAgreePublications="agreePublications = $event"
                :agreeEcda="agreeEcda"
                @changeAgreeEcda="agreeEcda = $event"
                :preschoolInfo="preschoolInfo"
                group="PRE"
                style="margin-bottom: 2rem"
              />

              <div class="row m-0" style="display: grid; grid-template-columns: 1fr 1fr; column-gap: 2rem">
                <div>
                  <div :class="{ 'form-group--error': $v.daSignatureName.$error }">
                    <label>
                      <span>* Name of Parent / Guardian </span>
                      <small v-if="!daSignatureName" style="color: red"><b>Please check at step 3</b></small>
                    </label>
                    <input class="form-control" type="text" v-model="daSignatureName" disabled />
                    <div class="error requiredFieldsMsg" v-if="!$v.daSignatureName.required" style="margin-bottom: 10px">
                      <el-alert title="Name of Parent / Guardian is required." type="error"></el-alert>
                    </div>
                  </div>

                  <div>
                    <label>* Date</label>
                    <el-date-picker
                      disabled
                      type="date"
                      v-model="daSignatureDate"
                      format="dd/MM/yyyy"
                      value-format="dd/MM/yyyy"
                      placeholder="Pick a day"
                      :picker-options="datePicker"
                    />
                  </div>
                </div>

                <div :class="{ 'form-group--error': $v.daSignature.$error }">
                  <label
                    >* Signature <small v-if="!daSignatureName" style="color: red"> <b>Please check at step 3</b></small></label
                  >
                  <div
                    style="
                      border: 1px solid whitesmoke;
                      height: 120px;
                      width: 100%;
                      background: whitesmoke;
                      border-radius: 6px;
                      cursor: pointer;
                      max-height: 120px;
                      overflow: auto;
                    "
                  >
                    <img v-if="daSignature" :src="daSignature" type="file" style="height: 100%; width: 100%; object-fit: contain" class="imgParentSignature" />
                  </div>
                  <div class="error requiredFieldsMsg" v-if="!$v.daSignature.required" style="margin-bottom: 10px">
                    <el-alert title="Signature is required." type="error"></el-alert>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="currentStep === 4">
          <label class="common-label-title" style="margin-bottom: 0">Document Checklist for Parents</label>
          <p style="color: #212121">
            (To submit more than one document for each field, select the required documents and upload them at the same time. Only .jpg, .png and .pdf files
            will be accepted and total file size should not be more than 10MB. You may still submit your application even if you do not have all documents now.
            However, kindly note that we will only review your application after all required information and documents have been submitted at least 3 working
            days before the next Admission Panel.)
          </p>
          <ApfDocumentChecklist
            :arrChecklistAttach="apat_ids"
            :validator="$v"
            :preSchoolInfo="preschoolInfo"
            group="PRE"
            :selectOptSchool="selectOptSchool"
            :apat_ids="apat_ids"
            @onFileChanged="onFileChanged"
            @removeChecklistAttach="removeAttachmentID"
          />
        </div>

        <div v-show="currentStep === 5" style="padding-top: 1rem">
          <ApfReferralChannelSelector group="EH" style="margin-bottom: 1rem" @change="trafficChannel = $event" :channel="trafficChannel" />

          <strong>2. If you have authorised a representative to assist you with this application, please fill in their information below:</strong>
          <div style="display: grid; grid-template-columns: 1fr 1fr; column-gap: 2rem; margin: 0.5rem 0">
            <div>
              <label>Name</label>
              <input class="form-control" type="text" v-model="raAgentName" />
            </div>
            <div>
              <label>Email</label>
              <input class="form-control" type="text" v-model="raAgentEmail" />
            </div>
            <div>
              <label>Company Name</label>
              <input class="form-control" type="text" v-model="raAgentCompanyName" />
            </div>
            <div>
              <label>Contact Number</label>
              <input class="form-control" type="text" v-model="raAgentTel" />
            </div>
          </div>
        </div>

        <div style="margin: 20px 0 0 0; background: #eeeeee; padding: 10px; display: flex; justify-content: space-between; flex-wrap: wrap">
          <button class="btn btn-success" v-if="currentStep === apfConfig.preSteps.length - 1" @click="validationForm()">Submit Application</button>
          <div style="display: flex; gap: 10px; margin-left: auto">
            <button class="btn btn-primary" v-if="currentStep >= 0 && currentStep < apfConfig.preSteps.length" @click="saveDraft()">Save As Draft</button>
            <button class="btn btn-primary" v-if="currentStep > 0 && currentStep <= apfConfig.preSteps.length - 1" @click="changeStep('prev')">Previous</button>
            <button class="btn btn-primary" v-if="currentStep >= 0 && currentStep < apfConfig.preSteps.length - 1" @click="changeStep('next')">Next</button>
          </div>
        </div>
        <div v-if="validationErrors.length > 0" style="padding: 0.5rem 0">
          <div class="el-alert el-alert--error is-light" style="display: block">
            <div style="font-weight: bold">Please fill in the following required fields before saving draft or submit application form:</div>
            <ol class="el-alert__content" style="padding-left: 2rem; padding-bottom: 0">
              <li v-for="[errKey] in validationErrors" :key="errKey">{{ getValidationMessageFromKey(errKey) }}</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <ApfAfterSubmitMessage group="EH" v-else-if="isSubmitted" />
    <ApfAfterSaveDraftMessage group="EH" v-else-if="isDraft" />
    <ApfSignaturePadModal @save="saveSignature($event)" />
    <ApfEmailVerificationModal @verify="setupDraft($event)" />
  </div>
</template>

<script>
import DataSource from '../../data/datasource'
import { lang } from '@/locale'
import moment from 'moment'
import ApfSelectSchoolDropdown from '@/pages/application/components/ApfSelectSchoolDropdown'
import ApfUploadStudentPhoto from '@/pages/application/components/ApfUploadStudentPhoto'
import ApfBasicInput from '@/pages/application/components/ApfBasicInput'
import { getValidationMessageFromKey, schools, preSchools, beachValidations, preSchoolValidations } from './data.js'

import ApfLanguageSection from '@/pages/application/components/ApfLanguageSection'
import ApfQuestions from '@/pages/application/components/ApfQuestions'
import ApfDeclarationAndAgreement from '@/pages/application/texts/ApfDeclarationAndAgreement'
import ApfReferralChannelSelector from '@/pages/application/components/ApfReferralChannelSelector'
import ApfAfterSubmitMessage from '@/pages/application/texts/ApfAfterSubmitMessage'
import ApfAfterSaveDraftMessage from '@/pages/application/texts/ApfAfterSaveDraftMessage'
import ApfSignaturePadModal from '@/pages/application/components/ApfSignaturePadModal'
import ApfEmailVerificationModal from '@/pages/application/components/ApfEmailVerificationModal'
import K2Row from '@/uiComponents/k2Row/k2Row'
import MultiEmailInput from '@/pages/application/components/multiEmailInput'
import ApfDocumentChecklist from '@/pages/application/components/ApfDocumentChecklist'
import appCustomTextConst, { ehCustomTextConst } from '@/pages/application/const/applicationCustomTextConst'
import apfConfig from '@/pages/application/config/apfConfig'
import AppInputPhoneNumber from '@/components/AppInputPhoneNumber.vue'

export default {
  validations() {
    switch (this.selectOptSchool) {
      case schools.Beach:
        return beachValidations
      default:
        return preSchoolValidations
    }
  },
  name: 'StudentApplicationForm',
  components: {
    ApfDocumentChecklist,
    MultiEmailInput,
    K2Row,
    ApfEmailVerificationModal,
    ApfSignaturePadModal,
    ApfAfterSaveDraftMessage,
    ApfAfterSubmitMessage,
    ApfReferralChannelSelector,
    ApfDeclarationAndAgreement,
    ApfQuestions,
    ApfLanguageSection,
    ApfBasicInput,
    ApfUploadStudentPhoto,
    ApfSelectSchoolDropdown,
    AppInputPhoneNumber,
  },
  data() {
    return {
      apfConfig,
      appCustomTextConst: appCustomTextConst,
      preSchools,
      schools,
      currentStep: 0,
      selectOptSchool: null,
      currentStudentImgPreview: '',
      preschoolInfo: null,
      agreePublications: 'Yes',
      agreeEcda: '',
      arrCountryList: [],
      currentAPFPID: '',
      allUploadFiles: [],
      uploadedStuImg: [],
      existingApfId: '',
      studProfilePic: '',
      studCommencementDate: '',
      studYearLevel: '',
      studFirstName: '',
      studLastName: '',
      APF_Preferred_Name: '',
      studDOB: '',
      studGender: '',
      studCOB: '',
      studNationality: '',
      studCurrentYearLevel: '',
      studCurrentSchName: '',
      studCurrentSchCountry: '',
      studIsEnrolled: '',
      studIsEnrolledSchool: '',
      studPassApplication: '',
      studImmigrationStatus: '',
      studImmigrationStatusNo: '',
      studImmigrationStatusNoExpiryDate: '',
      studFirstLanguage: '',
      studSecondLanguage: '',
      studLanguage: '',
      studArrLanguage: [],
      studArrLanguageList: [{ prop: 'studLang', label: 'Language' }],
      studArrLanguageListAction: {
        label: 'Delete',
        props: { align: 'center' },
        buttons: [
          {
            props: { type: 'primary', icon: 'el-icon-edit' },
            handler: row => {
              this.studArrLanguage.splice(this.studArrLanguage.indexOf(row), 1)
            },
            label: 'Delete',
          },
        ],
      },
      studSiblingName: '',
      studSiblingGender: '',
      studSiblingDOB: '',
      studSiblingPresentSch: '',
      studSiblingOtherSch: '',
      studSiblingAge: '',
      studArrSiblingDetails: [],
      studArrSiblingDetailsList: [
        { prop: 'APS_Name', label: 'Name' },
        { prop: 'APS_Gender', label: 'Gender' },
        { prop: 'APS_DOB', label: 'Date of Birth' },
        { prop: 'APS_PresentSchool', label: 'Current School' },
      ],
      studArrSiblingDetailsListAction: {
        label: 'Delete',
        props: { align: 'center' },
        buttons: [
          {
            props: { type: 'primary', icon: 'el-icon-edit' },
            handler: row => {
              this.studArrSiblingDetails.splice(this.studArrSiblingDetails.indexOf(row), 1)
              this.handleSiblingTable(true)
            },
            label: 'Delete',
          },
        ],
      },
      selectOptParent: 'fnm',
      arrOptParent: [
        { name: 'Father', value: 'father' },
        { name: 'Mother', value: 'mother' },
        { name: 'Father & Mother', value: 'fnm' },
      ],
      imageUrl: '',
      faFirstName: '',
      faLastName: '',
      faMiddleName: '',
      APFP_FatherDob: '',
      faNationality: '',
      faEmail: '',
      faTelM: '',
      faTelH: '',
      faResidencyDocNo: '',
      faResidencyDocExpiry: '',
      faCompanyName: '',
      faOccupation: '',
      maFirstName: '',
      maLastName: '',
      maMiddleName: '',
      APFP_MotherDob: '',
      maNationality: '',
      maEmail: '',
      maTelM: '',
      maTelH: '',
      maResidencyDocNo: '',
      maResidencyDocExpiry: '',
      maCompanyName: '',
      maOccupation: '',
      parHouseholdIncome: '',
      gdName: '',
      gdEmail: '',
      gdTelM: '',
      gdTelH: '',
      emgPerson1: '',
      emgRelationship1: '',
      emgTelM1: '',
      emgTelH1: '',
      emgPerson2: '',
      emgRelationship2: '',
      emgTelM2: '',
      emgTelH2: '',
      corrResidingType: '',
      corrAddress: '',
      corrAddressPostal: '',
      corrAddressCountry: 'Singapore',
      billName: '',
      billAddress: '',
      billAddressPostal: '',
      billAddressCountry: 'Singapore',
      billEmail: '',
      billTel: '',
      siSignatureName: '',
      siSignature: '',
      siSignatureDate: '',
      daSignatureName: '',
      daSignature: '',
      daSignatureDate: '',
      daSignatureAPATID: '',
      siSignatureAPATID: '',
      currentStudentImageAPATID: '',
      raAgentName: '',
      raAgentEmail: '',
      raAgentTel: '',
      raAgentCompanyName: '',
      trafficChannel: '',
      // arrChecklistAttach: [],
      arrChecklistPrevAttach: [],
      signatureType: '',
      questionAryObj: [],
      schoolNameList: [],
      ddlSchoool: [],
      isSubmitted: false,
      isDraft: false,
      inputFirstCommencementDate: '',
      autoLevel: '',
      isStudHasSibling: 'No',
      studISDoc: [],
      apat_ids: [],
      apatList: [],
      InternationalSchoolNameList: '',
      bilingualYesNoValue: '',
      additionalLangValue: [],
      langValue: '',
      inputStudentEmailAdd: '',
      datePicker: {
        disabledDate(date) {
          return date > new Date().getTime()
        },
      },
      CommDatePicker: {
        disabledDate(time) {
          return time.getDay() === 0 || time.getDay() === 6
        },
      },
    }
  },
  props: [],
  async mounted() {
    window.pageApp = this
    if (this.$route.query.ID) {
      this.$bvModal.show('emailVerificationModal')
    } else {
      await this.getTodayDate()
      await this.BindCountryList()
      await this.BindQuestion()
      await this.BindSchoolDropdown()
    }
  },
  methods: {
    lang,
    getValidationMessageFromKey,
    onSelection(event) {
      const data = event.target.value
      this.studImmigrationStatus = data === 'yes' ? 'STPIP(Student Pass In Progress)' : ''
    },
    onBillingNameChange() {
      this.$v.maCompanyName.$touch()
      this.$v.faCompanyName.$touch()
    },
    async getDraftApplicationForm(appId) {
      const resp = await DataSource.shared.getDraftApplicationForm(appId)
      if (resp?.code === '99') {
        return this.flashError('Failed to retrieve draft application.')
      }
      resp.FormTable.forEach(m => {
        this.onSchoolChange(m?.APF_ApplicationSchool)
        this.currentAPFPID = m.APFP_ID
        const fatherEmail = m.APFP_FatherPersonalEmail ?? ''
        const motherEmail = m.APFP_MotherPersonalEmail ?? ''
        if (fatherEmail !== '' && motherEmail !== '') {
          this.selectOptParent = 'fnm'
          this.faEmail = m.APFP_FatherPersonalEmail
          this.maEmail = m.APFP_MotherPersonalEmail
        } else if (fatherEmail !== '') {
          this.selectOptParent = 'father'
          this.faEmail = m.APFP_FatherPersonalEmail
        } else if (motherEmail !== '') {
          this.selectOptParent = 'mother'
          this.maEmail = m.APFP_MotherPersonalEmail
        }
        this.studFirstName = m.APF_FirstName ?? ''
        this.studLastName = m.APF_Surname ?? ''
        this.APF_Preferred_Name = m.APF_Preferred_Name ?? ''
        this.studDOB = m.APF_DOB ?? ''
        this.studCOB = m.APF_POB ?? ''
        this.studCurrentSchName = m.APF_CurrentSchool ?? ''
        this.studCurrentSchCountry = m.APF_CurrentCountry ?? ''
        this.inputFirstCommencementDate = m.APF_CommencementDate?.substring(0, 10) ?? ''
        this.studImmigrationStatus = m.APF_IDType ?? ''
        this.studImmigrationStatusNo = m.APF_IDNumber ?? ''
        this.studGender = m.APF_Gender ?? ''
        this.studNationality = m.APF_Nationality ?? ''
        this.studIsEnrolled = m.APF_EnrolPreviously ?? ''
        this.studPassApplication = m.APF_RequireApplyStudPass ?? ''
        this.studIsEnrolledSchool = m.APF_EnrolPreviouslySchool ?? ''
        this.studImmigrationStatusNoExpiryDate = m.APF_IDPASSExpiredDate?.substring(0, 10) ?? ''
        this.studFirstLanguage = m.APF_1stLang ?? ''
        this.studSecondLanguage = m.APF_2ndLang ?? ''
        this.emgPerson1 = m.APF_Emer1Name ?? ''
        this.emgRelationship1 = m.APF_Emer1Relation ?? ''
        this.emgTelM1 = m.APF_Emer1Mobile ?? ''
        this.emgTelH1 = m.APF_Emer1Tel ?? ''
        this.emgPerson2 = m.APF_Emer2Name ?? ''
        this.emgRelationship2 = m.APF_Emer2Relation ?? ''
        this.emgTelM2 = m.APF_Emer2Mobile ?? ''
        this.emgTelH2 = m.APF_Emer2Tel ?? ''
        this.corrResidingType = m.APF_CorrResidingWith ?? ''
        this.corrAddress = m.APF_CorrAddress ?? ''
        this.corrAddressPostal = m.APF_CorrPostal ?? ''
        this.corrAddressCountry = m.APF_CorrCountry ?? ''
        this.billName = m.APF_BillingName ?? ''
        this.billAddress = m.APF_BillingAddress ?? ''
        this.billAddressPostal = m.APF_BillingPostal ?? ''
        this.billAddressCountry = m.APF_BillingCountry ?? ''
        this.billEmail = m.APF_BillingEmail ?? ''
        this.billTel = m.APF_BillingTel ?? ''
        this.raAgentName = m.APF_ReferralAgentName ?? ''
        this.raAgentEmail = m.APF_ReferralAgentEmail ?? ''
        this.raAgentTel = m.APF_ReferralAgentTel ?? ''
        this.raAgentCompanyName = m.APF_ReferralCompany ?? ''
        this.bilingualYesNoValue = m.APF_BilingualProgram ?? ''
        this.additionalLangValue = m.APF_AdditionalLanguage ? m.APF_AdditionalLanguage?.split(', ') : []

        this.langValue = m.APF_Language ?? ''
        this.trafficChannel = m.APF_TrafficChannel ?? ''
        this.faFirstName = m.APFP_FatherFirstName ?? ''
        this.faLastName = m.APFP_FatherLastName ?? ''
        this.faNationality = m.APFP_FatherNationality ?? ''
        this.faResidencyDocNo = m.APFP_FatherResidencyDocNo ?? ''
        this.faOccupation = m.APFP_FatherOccupation ?? ''
        this.faCompanyName = m.APFP_FatherCompanyName ?? ''
        this.faTelM = m.APFP_FatherMobile ?? ''
        this.faTelH = m.APFP_FatherHomeTel ?? ''
        this.faEmail = m.APFP_FatherPersonalEmail ?? ''
        this.faMiddleName = m.APFP_FatherMiddleName ?? ''
        this.APFP_FatherDob = m.APFP_FatherDob?.substring(0, 10) ?? ''
        this.faResidencyDocExpiry = m.APFP_FatherResidencyDocExpiry?.substring(0, 10) ?? ''
        this.maFirstName = m.APFP_MotherFirstName ?? ''
        this.maLastName = m.APFP_MotherLastName ?? ''
        this.maNationality = m.APFP_MotherNationality ?? ''
        this.maResidencyDocNo = m.APFP_MotherResidencyDocNo ?? ''
        this.maOccupation = m.APFP_MotherOccupation ?? ''
        this.maCompanyName = m.APFP_MotherCompanyName ?? ''
        this.maTelM = m.APFP_MotherMobile ?? ''
        this.maTelH = m.APFP_MotherHomeTel ?? ''
        this.maEmail = m.APFP_MotherPersonalEmail ?? ''
        this.maMiddleName = m.APFP_MotherMiddleName ?? ''
        this.APFP_MotherDob = m.APFP_MotherDob?.substring(0, 10) ?? ''
        this.maResidencyDocExpiry = m.APFP_MotherResidencyDocExpiry?.substring(0, 10) ?? ''
        this.gdName = m.APFP_LegalGuardianName ?? ''
        this.gdEmail = m.APFP_LegalGuardianEmail ?? ''
        this.gdTelM = m.APFP_LegalGuardianMobile ?? ''
        this.gdTelH = m.APFP_LegalGuardianHomeTel ?? ''
        this.agreePublications = m.APF_DeclarePublication ?? ''
        this.agreeEcda = m.APF_DeclareEcda ?? ''
        this.studArrSiblingDetails = resp.SiblingTable
        this.isStudHasSibling = resp.SiblingTable.length > 0 ? 'Yes' : 'No'
        this.parHouseholdIncome = m.APFP_AnnualHouseHoldIncome ?? ''

        const attachTableList = resp.AttachTable
        attachTableList.forEach(n => {
          if (n.APAT_UploadType === 'stuIMG') {
            this.currentStudentImgPreview = n.APAT_FilePath + n.APAT_EnrolFileName + n.APAT_EnrolFileExt
            this.currentStudentImageAPATID = n.APAT_ID
          }
          if (n.APAT_UploadType === 'Declare & Agreement') {
            this.daSignature = n.APAT_FilePath + n.APAT_EnrolFileName + n.APAT_EnrolFileExt
            this.daSignatureAPATID = n.APAT_ID
            this.daSignatureName = n.APAT_SignatureName
          }
          if (n.APAT_UploadType === 'Supporting Information') {
            this.siSignature = n.APAT_FilePath + n.APAT_EnrolFileName + n.APAT_EnrolFileExt
            this.siSignatureAPATID = n.APAT_ID
            this.siSignatureName = n.APAT_SignatureName
          }
          const uploadTypes = ['stuIMG', 'Declare & Agreement', 'Supporting Information', 'studISDoc']
          if (n.APAT_UploadType === 'studISDoc' || !uploadTypes.includes(n.APAT_UploadType)) {
            n.attType = n.APAT_UploadType
            n.attFile = new Array({ data: {} })
            n.attFile.forEach(f => {
              f.apat_id = n.APAT_ID
              f.attType = n.APAT_UploadType
              f.name = n.APAT_EnrolFileName
              f.url = n.APAT_FilePath + n.APAT_EnrolFileName + n.APAT_EnrolFileExt
              n.attFile.push(f)
            })
            n.attFile = [...new Set(n.attFile)]
            if (n.APAT_UploadType === 'studISDoc') this.studISDoc.push(n)
            else this.apat_ids.push(n)
            this.arrChecklistPrevAttach.push(n)
            this.arrChecklistPrevAttach.push(n)
          }
        })
      })
      const AnswerTableList = resp.AnswerTable
      this.questionAryObj.forEach(f => {
        AnswerTableList.forEach(m => {
          if (f.APFQ_ID === m.APFQ_ID) {
            f.newAnswer = m.APFA_Answer
            f.newAnswerValue = m.APFA_AnswerValue
            f.newAnswerValue1 = m.APFA_AnswerValue1
            f.newAnswerValue2 = m.APFA_AnswerValue2
            return false
          }
        })
      })
    },

    getTodayDate() {
      const currentDate =
        new Date().getFullYear() + '-' + String(new Date().getMonth() + 1).padStart(2, '0') + '-' + String(new Date().getDate()).padStart(2, '0')
      this.siSignatureDate = currentDate
      this.daSignatureDate = currentDate
    },

    clickStep(index) {
      this.currentStep = index
    },

    changeStep(type) {
      if (type === 'prev') {
        this.currentStep = this.currentStep - 1
      } else {
        this.currentStep = this.currentStep + 1
      }
      window.scrollTo(0, 0)
    },
    handleSiblingTable(isRemove) {
      if (isRemove) {
        const siblingAgeExist = this.studArrSiblingDetails?.filter(d => d.APS_Age?.trim() !== '')
        if (siblingAgeExist?.length < 1) {
          this.studArrSiblingDetailsList = this.studArrSiblingDetailsList.filter(d => d.prop !== 'APS_Age')
        }

        const otherSchoolExist = this.studArrSiblingDetails?.filter(d => d.APS_OtherSchool)
        if (otherSchoolExist?.length < 1) {
          this.studArrSiblingDetailsList = this.studArrSiblingDetailsList.filter(d => d.prop !== 'APS_OtherSchool')
        }
      } else {
        if (this.studSiblingOtherSch) {
          this.studArrSiblingDetailsList.push({ prop: 'APS_OtherSchool', label: 'Other School' })
        }
        if (this.studSiblingAge) {
          this.studArrSiblingDetailsList.push({ prop: 'APS_Age', label: 'Age' })
        }
      }
    },
    addStudSibling() {
      if (!this.studSiblingName) return this.flashError('Please fill in sibling name.')
      if (!this.studSiblingGender) return this.flashError('Please select sibling gender.')
      if (!this.studSiblingDOB) return this.flashError('Please select sibling date of birth.')
      this.handleSiblingTable()
      this.studArrSiblingDetails.push({
        APS_Name: this.studSiblingName,
        APS_Gender: this.studSiblingGender,
        APS_DOB: this.studSiblingDOB,
        APS_PresentSchool: this.studSiblingPresentSch,
        APS_OtherSchool: this.studSiblingOtherSch,
        APS_Age: this.studSiblingAge,
      })
      this.studSiblingName = ''
      this.studSiblingGender = ''
      this.studSiblingDOB = ''
      this.studSiblingPresentSch = ''
      this.studSiblingOtherSch = ''
      this.studSiblingAge = ''
    },

    async onFileChanged(event, attType) {
      const files = event.target?.files ?? event
      if (files.length > 0) {
        let eachObjAttachment = {}
        eachObjAttachment.attType = attType
        this.arr_SelectedFileList = []
        let isUploadFile = true
        for await (let file of files) {
          let fileSize = file.size / 1024 / 1024
          if (fileSize > 10) {
            isUploadFile = false
            this.$notify.error({
              title: 'Error',
              message: 'File limit exceeded 10MB',
            })
          }
        }
        if (isUploadFile) {
          for await (let file of files) {
            file.url = URL.createObjectURL(file)
          }
          eachObjAttachment.attFile = files
        }
        // Note: Upload file asynchronously using this API to prevent form submission delay
        await this.checkAttachmentID(eachObjAttachment)
        await this.saveApplicationAttachment(eachObjAttachment)

        // if (attType === 'studISDoc') this.studISDoc.push(eachObjAttachment);
        // else this.arrChecklistAttach.push(eachObjAttachment);
      }
    },

    async saveApplicationAttachment(eachObjAttachment) {
      this.$vs.loading()
      if (eachObjAttachment?.attFile?.length > 0) {
        try {
          const response = await DataSource.shared.saveApplicationAttachment(eachObjAttachment.attFile, eachObjAttachment.attType)
          if (response) {
            if (response?.length !== eachObjAttachment.attFile?.length) {
              this.flashError('Unknown Error! Please contact support.')
            } else {
              let newUpload = response?.map(d => {
                d.attType = eachObjAttachment.attType
                return d
              })
              this.apat_ids.push(...newUpload)
            }
          }
        } catch (e) {
          console.log(e)
        }
      }
      this.$vs.loading.close()
    },

    checkAttachmentID(objAttach) {
      this.apat_ids.forEach(att => {
        if (att.attType === objAttach.attType) {
          this.apat_ids.splice(this.apat_ids.indexOf(att), 1)
        }
      })
    },

    async removeAttachmentID(objAttach) {
      this.apat_ids = this.apat_ids?.filter(d => d.APAT_ID !== objAttach.APAT_ID)
    },

    // checkAttachment(objAttach) {
    // 	this.arrChecklistAttach.forEach(att => {
    // 		if (att.attType === objAttach.attType) {
    // 			this.arrChecklistAttach.splice(this.arrChecklistAttach.indexOf(att), 1);
    // 		}
    // 	});
    // },

    async BindQuestion() {
      const resp = await DataSource.shared.getApplicationQuestion()
      let assignedList = []
      resp.Table.forEach(m => {
        let tempList = {
          newAnswer: m.newAnswer,
          newAnswerValue: m.newAnswerValue,
          newAnswerValue1: m.newAnswerValue1,
          newAnswerValue2: m.newAnswerValue2,
          APFQ_Desc: m.APFQ_Desc,
          APFQ_ID: m.APFQ_ID,
          APFQ_Ordering: m.APFQ_Ordering,
          APFQ_Status: m.APFQ_Status,
          APFQ_Type: m.APFQ_Type,
        }
        assignedList.push(tempList)
      })
      this.questionAryObj = assignedList
    },

    async BindCountryList() {
      try {
        await this.$vs.loading()
        const response = await DataSource.shared.getCountryListWithoutToken()
        this.arrCountryList = response.Table
      } finally {
        await this.$vs.loading.close()
      }
    },

    async saveApplicationForm(asDraft = false) {
      await this.$vs.loading()
      try {
        let studObj = {
          APF_Surname: this.studLastName,
          APF_FirstName: this.studFirstName,
          APF_Preferred_Name: this.APF_Preferred_Name,
          APF_DOB: this.studDOB,
          APF_POB: this.studCOB,
          APF_CommencementDate: this.inputFirstCommencementDate,
          APF_IDType: this.studImmigrationStatus,
          APF_IDNumber: this.studImmigrationStatusNo,
          APF_Gender: this.studGender,
          APF_HomeAddress: this.corrAddressSingapore,
          APF_Nationality: this.studNationality,
          APF_CurrentSchool: this.studCurrentSchName,
          APF_CurrentCountry: 'Singapore',
          APF_RequireApplyStudPass: this.studPassApplication,
          APF_EnrolPreviously: this.studIsEnrolled,
          APF_EnrolPreviouslySchool: this.studIsEnrolledSchool,
          APF_IDPASSExpiredDate: this.studImmigrationStatusNoExpiryDate,
          APF_1stLang: this.studFirstLanguage,
          APF_2ndLang: this.studSecondLanguage,
          APF_Emer1Name: this.emgPerson1,
          APF_Emer1Relation: this.emgRelationship1,
          APF_Emer1Tel: this.emgTelH1,
          APF_Emer1Mobile: this.emgTelM1,
          APF_Emer2Name: this.emgPerson2,
          APF_Emer2Relation: this.emgRelationship2,
          APF_Emer2Tel: this.emgTelH2,
          APF_Emer2Mobile: this.emgTelM2,
          APF_CorrResidingWith: this.corrResidingType,
          APF_CorrAddress: this.corrAddress,
          APF_CorrPostal: this.corrAddressPostal,
          APF_CorrCountry: this.corrAddressCountry,
          APF_BillingName: this.billName,
          APF_BillingAddress: this.billAddress,
          APF_BillingPostal: this.billAddressPostal,
          APF_BillingCountry: this.billAddressCountry,
          APF_BillingEmail: this.billEmail,
          APF_BillingTel: this.billTel,
          APF_ReferralAgentName: this.raAgentName,
          APF_ReferralAgentEmail: this.raAgentEmail,
          APF_ReferralAgentTel: this.raAgentTel,
          APF_ReferralCompany: this.raAgentCompanyName,
          APF_BilingualProgram: this.bilingualYesNoValue,
          APF_AdditionalLanguage: this.additionalLangValue.join(', '),
          APF_Language: this.langValue,
          APF_TrafficChannel: this.trafficChannel,
          APF_DeclarePublication: this.agreePublications,
          APF_DeclareEcda: this.agreeEcda,
        }

        let parentObj = {
          APFP_FatherFirstName: this.faFirstName,
          APFP_FatherLastName: this.faLastName,
          APFP_FatherNationality: this.faNationality,
          APFP_FatherResidencyDocNo: this.faResidencyDocNo,
          APFP_FatherResidencyDocExpiry: this.faResidencyDocExpiry,
          APFP_FatherOccupation: this.faOccupation,
          APFP_FatherCompanyName: this.faCompanyName,
          APFP_FatherMobile: this.faTelM,
          APFP_FatherHomeTel: this.faTelH,
          APFP_FatherPersonalEmail: this.faEmail,
          APFP_FatherMiddleName: this.faMiddleName,
          APFP_FatherDob: this.APFP_FatherDob,
          APFP_MotherFirstName: this.maFirstName,
          APFP_MotherLastName: this.maLastName,
          APFP_MotherNationality: this.maNationality,
          APFP_MotherResidencyDocNo: this.maResidencyDocNo,
          APFP_MotherResidencyDocExpiry: this.maResidencyDocExpiry,
          APFP_MotherOccupation: this.maOccupation,
          APFP_MotherCompanyName: this.maCompanyName,
          APFP_MotherMobile: this.maTelM,
          APFP_MotherHomeTel: this.maTelH,
          APFP_MotherPersonalEmail: this.maEmail,
          APFP_MotherMiddleName: this.maMiddleName,
          APFP_MotherDob: this.APFP_MotherDob,
          APFP_LegalGuardianName: this.gdName,
          APFP_LegalGuardianEmail: this.gdEmail,
          APFP_LegalGuardianMobile: this.gdTelM,
          APFP_LegalGuardianHomeTel: this.gdTelH,
          APFP_AnnualHouseHoldIncome: this.parHouseholdIncome,
        }

        let arrDeclare = []

        if (this.siSignature !== '') {
          let declareObj = {
            SignatureName: this.siSignatureName,
            Signature: this.siSignature,
            SignatureType: 'Supporting Information',
            SignatureAPATID: this.siSignatureAPATID,
            DeclarePublication: this.agreePublications,
            DeclareEcda: this.agreeEcda,
          }
          arrDeclare.push(declareObj)
        }

        if (this.daSignature !== '') {
          let declareObj = {
            SignatureName: this.daSignatureName,
            Signature: this.daSignature,
            SignatureType: 'Declare & Agreement',
            SignatureAPATID: this.daSignatureAPATID,
          }
          arrDeclare.push(declareObj)
        }

        // if (this.uploadedStuImg.length > 0) {
        // 	this.allUploadFiles.push(this.uploadedStuImg[0]);
        // }
        //
        // if (this.studISDoc.length > 0) {
        // 	this.studISDoc.forEach(cFile => {
        // 		if (cFile.attFile.length > 0) {
        // 			cFile.attFile.forEach(aFile => {
        // 				aFile.uploadType = cFile.attType;
        // 				this.allUploadFiles.push(aFile);
        // 			});
        // 		}
        // 	});
        // 	this.allUploadFiles = [...new Set(this.allUploadFiles)];
        // 	this.studISDoc.push(this.allUploadFiles);
        // }
        // if (this.arrChecklistAttach.length > 0) {
        // 	this.arrChecklistAttach.forEach(cFile => {
        // 		// BUG HERE where cFile is a list of files[] and there is no .attFile prop
        // 		if (cFile.attFile && cFile.attFile.length > 0) {
        // 			cFile.attFile.forEach(aFile => {
        // 				aFile.uploadType = cFile.attType;
        // 				this.allUploadFiles.push(aFile);
        // 			});
        // 		}
        // 	});
        // 	this.allUploadFiles = [...new Set(this.allUploadFiles)];
        // 	this.arrChecklistAttach.push(this.allUploadFiles);
        // }
        const apat_idList = this.apat_ids?.map(d => d.APAT_ID).join(',')
        const res = await DataSource.shared.saveApplicationForm(
          asDraft ? 'Draft' : 'Pending',
          JSON.stringify(this.arrChecklistPrevAttach),
          null,
          JSON.stringify(studObj),
          JSON.stringify(parentObj),
          JSON.stringify(this.questionAryObj),
          JSON.stringify(this.studArrSiblingDetails),
          JSON.stringify(arrDeclare),
          this.selectOptSchool,
          this.existingApfId,
          this.currentAPFPID,
          this.currentStudentImageAPATID,
          apat_idList
        )
        const code = Number(res?.code || 0)
        if (code !== 1) {
          this.flashError(res?.message || 'Unknown Error! Please contact support.')
          return
        }
        this.$notify({
          title: 'Success',
          message: 'Records Successfully Saved',
          type: 'success',
        })
        if (asDraft) this.isDraft = true
        else this.isSubmitted = true
      } finally {
        this.$vs.loading.close()
      }
    },

    async validationForm() {
      this.$v.$touch()
      if (this.$v.$error) {
        return this.flashError('Please fill in all * fields')
      }
      window.scrollTo(0, 0)
      await this.saveApplicationForm()
    },

    async BindSchoolDropdown() {
      try {
        await this.$vs.loading()
        const response = await DataSource.shared.getSchoolDropdownList('UTY201300000061') // UTY201300000061
        if (response && response.code !== '88') {
          this.ddlSchoool = preSchools.currentSchoolDropdown
          this.schoolNameList = response.Table.filter(
            n =>
              !['SCH201400000028', 'SCH201400000037', 'SCH202000000565', 'SCH202100000566', 'SCH202100000567', 'SCH201700000404', 'SCH20120000001'].includes(
                n.SchoolID
              )
          ).map(n => {
            if (['SCH201400000480', 'SCH201400000510', 'SCH201400000553'].includes(n.SchoolID)) n.SchoolName = n.SchoolName.replace('M', 'Mountbatten ')
            return n
          })
        }
      } finally {
        await this.$vs.loading.close()
      }
    },

    async saveSignature(data) {
      this.signatureType = 'si'
      this.siSignature = data
      this.daSignature = data
    },

    checkStudentAge() {
      let bDay = ''
      let convertedBday = ''
      if (!this.studDOB) {
      } else {
        let splittedDate = this.studDOB.split('-')
        bDay = [splittedDate[1], splittedDate[2], splittedDate[0]].join('/')
        convertedBday = bDay.substring(2)
      }
      convertedBday = moment(this.studDOB, 'DD/MM/YYYY').format('DD/MM/YYYY')
      this.getAutoAssignLevelAcademicYear(convertedBday)
    },

    async getAutoAssignLevelAcademicYear(formatterDateVal) {
      const convertCommencementDate = moment(this.inputFirstCommencementDate, 'DD/MM/YYYY').format('DD/MM/YYYY')
      if (formatterDateVal) {
        const response = await DataSource.shared.getAutoAssignLevelAcademicYear(convertCommencementDate, formatterDateVal, this.selectOptSchool)
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else {
            this.autoLevel = response.Table[0].level
            const age = Number(response.Table[0].age)
            if (age > 0) {
              const ageOutOfRange = (min, max) => age < min || age > max
              if (this.selectOptSchool === schools['Orchard'] && ageOutOfRange(6, 18))
                alert(`Please check DOB and commencement date is entered correctly, Orchard school only accepts students from Y1 to Y13`)
              if (this.selectOptSchool === schools['Broadrick'] && ageOutOfRange(4, 11))
                alert(`Please check DOB and commencement date is entered correctly, Broadrick school only accepts students from N2 to Y6`)
              if (this.selectOptSchool === schools['Sentosa Primary'] && ageOutOfRange(7, 10))
                alert(`Please check DOB and commencement date is entered correctly, Sentosa primary school only accepts students from Y2 to Y5`)
            }
          }
        }
      } else {
        this.autoLevel = ''
      }
    },

    async copySignaturenName() {
      this.daSignatureName = this.siSignatureName
    },

    resetBillingInfo() {
      this.billName = ''
      this.billAddress = ''
      this.billAddressPostal = ''
      this.billAddressCountry = 'Singapore'
      this.billEmail = ''
      this.billTel = ''
    },

    // async removeChecklistAttach(objAttach, attType) {
    // 	this.arrChecklistAttach.forEach(att => {
    // 		if (att.attType === attType && att.attFile.length > 0) {
    // 			const newFileList = Array.from(att.attFile);
    // 			for (let a = 0; a < att.attFile.length; a++) {
    // 				if (att.attFile[a].name === objAttach.name) {
    // 					newFileList.splice(newFileList.indexOf(objAttach), 1);
    // 				}
    // 			}
    // 			att.attFile = newFileList;
    // 		}
    // 	});
    // },

    async saveDraft() {
      const emailRegex =
        /^(?:[A-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9]{2,}(?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/
      const fatherEmail = this.faEmail.trim()
      const motherEmail = this.maEmail.trim()
      const guardianEmail = this.gdEmail.trim()
      const billingEmail = this.billEmail.trim()
      let ErrorMsg = ''
      if (this.selectOptParent === 'fnm') {
        this.$v.faEmail.$touch()
        this.$v.maEmail.$touch()
        if (fatherEmail.length === 0 || motherEmail.length === 0) {
          ErrorMsg = "Please provide either father's or mother's email address"
        } else {
          if (!emailRegex.test(fatherEmail) || !emailRegex.test(motherEmail)) {
            ErrorMsg = 'Invalid e-mail address'
          }
        }
      } else if (this.selectOptParent === 'father') {
        this.$v.faEmail.$touch()
        if (fatherEmail.length === 0) {
          ErrorMsg = "Please provide father's email address"
        } else {
          if (!emailRegex.test(fatherEmail)) {
            ErrorMsg = 'Invalid e-mail address'
          }
        }
      } else if (this.selectOptParent === 'mother') {
        this.$v.maEmail.$touch()
        if (motherEmail.length === 0) {
          ErrorMsg = "Please provide mother's email address"
        } else {
          if (!emailRegex.test(motherEmail)) {
            ErrorMsg = 'Invalid e-mail address'
          }
        }
      } else {
        if (guardianEmail.length === 0) {
          this.$v.gdEmail.$touch()
          ErrorMsg = "Please provide guardian's email address"
        } else {
          if (!emailRegex.test(guardianEmail)) {
            ErrorMsg = 'Invalid e-mail address'
          }
        }
      }
      if (ErrorMsg.trim().length > 0) {
        this.$notify.error({
          title: 'Error',
          message: ErrorMsg,
        })
        return
      }
      window.scrollTo(0, 0)
      await this.saveApplicationForm(true)
    },

    async setupDraft(apfId) {
      this.existingApfId = apfId
      await this.getTodayDate()
      await this.BindCountryList()
      await this.BindQuestion()
      await this.BindSchoolDropdown()
      await this.getDraftApplicationForm(this.existingApfId)
    },

    flashError(msg) {
      return this.$notify.error({ title: 'Error', message: msg })
    },

    onSchoolChange(val) {
      this.selectOptSchool = val
      this.preschoolInfo = preSchools.schoolsInfo.find(school => school?.schoolID === val)
      this.appCustomTextConst = ehCustomTextConst(true)
    },
  },

  computed: {
    validationErrors() {
      return Object.entries(this.$v).filter(([key, attr]) => attr?.$anyError)
    },
  },
}
</script>

<style>
@import './StudentApplicationForm.css';
</style>
